/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */

import { AvatarName, Question, SelectLang, ThemeToggle } from '@zhiyue/core';
import AvatarDropdown from './AvatarDropdown';
import AIButton from './ai-button';
import Footer from './Footer';
import ThemeProvider from './ThemeProvider';
import TrackButton from './track-button';

export {
  AIButton,
  AvatarDropdown,
  AvatarName,
  Footer,
  Question,
  SelectLang,
  ThemeProvider,
  ThemeToggle,
  TrackButton,
};
